import { CreditCardOutlined, DollarOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import type { JSX, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { PaymentMethod } from '../api/types';

const METHOD_ICON: Record<PaymentMethod, ReactNode> = {
  CASH: <DollarOutlined />,
  TERMINAL: <CreditCardOutlined />,
};

const METHOD_COLOR: Record<PaymentMethod, string> = {
  CASH: 'blue',
  TERMINAL: 'geekblue',
};

/** Наличные/Терминал marker on STORE_PAYMENT rows; renders nothing for null
 * (rows created before the field existed). */
export function PaymentMethodTag({ method }: { method: PaymentMethod | null }): JSX.Element | null {
  const { t } = useTranslation();
  if (!method) return null;
  return (
    <Tag icon={METHOD_ICON[method]} color={METHOD_COLOR[method]} style={{ marginInlineEnd: 0 }}>
      {t(`payMethod.${method}`)}
    </Tag>
  );
}
